import React from 'react'
import Link from 'next/link'
import { NextImage } from '@/components/NextImage'

import classes from '../styles.module.scss'

interface LogoProps {
  src: string
  width?: number
  height?: number
  testId?: string
  clickable?: boolean
}

const DEFAULT_DIMENSIONS = {
  width: 90,
  height: 60
}

export const Logo: React.FC<LogoProps> = ({
  src,
  width = DEFAULT_DIMENSIONS.width,
  height = DEFAULT_DIMENSIONS.height,
  testId,
  clickable = true
}) => {
  const imageElement = (
    <NextImage
      className={classes.logo}
      width={width}
      height={height}
      src={src}
      alt="Logo"
      priority
      data-testid={testId}
    />
  )

  if (!clickable) {
    return imageElement
  }

  return (
    <Link className={classes.logo} href="/" data-testid={testId}>
      {imageElement}
    </Link>
  )
}
